<template>
  <el-drawer size="1000px"
             :withHeader="false"
             :visible.sync="wxappVisible"
             :close-on-press-escape="false"
             :wrapperClosable="false"
             :before-close="handleClickClose">
    <div class="drawer_wrap">
      <div class="drawer_header">
        <h3 class="title">小程序设置</h3>
        <i class="el-icon-close" @click="handleClickClose"></i>
      </div>
      <div class="drawer_body">

        <el-form size="small"
                 ref="wxappForm"
                 label-position="top"
                 label-width="175px"
                 :model="wxappForm"
                 :rules="wxappFormRules" v-loading="loading">
          <el-form-item label="小程序AppID：" prop="app_id">
            <el-input placeholder="请输入小程序AppID" v-model="wxappForm.app_id"></el-input>
          </el-form-item>
          <el-form-item label="小程序AppSecret：" prop="app_secret">
            <el-input placeholder="请输入小程序AppSecret" v-model="wxappForm.app_secret"></el-input>
          </el-form-item>
          <el-form-item label="微信商户号MCHID：" prop="mchid">
            <el-input placeholder="请输入微信商户号MCHID" v-model="wxappForm.mchid"></el-input>
          </el-form-item>
          <el-form-item label="微信支付密钥APIKEY：" prop="apikey">
            <el-input placeholder="请输入微信支付密钥APIKEY" v-model="wxappForm.apikey"></el-input>
          </el-form-item>
          <el-form-item label="证书文件cert：" prop="cert_pem">
            <el-input type="textarea" :rows="5" placeholder="请输入证书文件cert" v-model="wxappForm.cert_pem"></el-input>
            <p class="hint">使用文本编辑器打开apiclient_cert.pem文件，将文件的全部内容复制进来</p>
          </el-form-item>
          <el-form-item label="证书文件key：" prop="key_pem">
            <el-input type="textarea" :rows="5" placeholder="请输入证书文件key" v-model="wxappForm.key_pem"></el-input>
            <p class="hint">使用文本编辑器打开apiclient_key.pem文件，将文件的全部内容复制进来</p>
          </el-form-item>
          <el-form-item label="小程序风格：" prop="style_type">
            <el-radio-group v-model="wxappForm.style_type">
              <el-radio :label="1">风格1</el-radio>
              <el-radio :label="2">风格2</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <div class="drawer_footer">
        <el-button size="small" @click="handleClickClose">取消</el-button>
        <el-button :disabled="btnDisabled" size="small" type="primary" @click="handleClickConfirm">确定
        </el-button>
      </div>
    </div>
  </el-drawer>

</template>
<script>

import { StoreWxappAdd ,StoreWxappEdit ,StoreWxappDetails } from '@/api'

export default {
    name: 'wxapp',
    props: {
        wxappVisible: {
            type: Boolean,
            default: false,
        },
		companyId: {
		    type: Number,
		    default: 0,
		},
		storeWxappId: {
		    type: Number,
		    default: 0,
		}

    },
    data () {
        return {
            wxappForm: {
                app_id: '', //小程序AppID
                app_secret: '', //小程序AppSecret
                mchid: '', //微信商户号ID
                apikey: '', //微信支付密钥
                cert_pem: '', //证书文件cert
                key_pem: '', //证书文件key
                style_type:1, //小程序风格
            },
            wxappFormRules: {
                app_id: [{required: true, trigger: 'blur', message: '请输入小程序AppID'}],
                app_secret: [{required: true, trigger: 'blur', message: '请输入小程序AppSecret'}],
                mchid: [{required: true, trigger: 'blur', message: '请输入微信商户号MCHID'}],
                apikey: [{required: true, trigger: 'blur', message: '请输入微信支付密钥APIKEY'}],
            },
			    loading:false,
         btnDisabled:false
        }
    },
    created () {
    },
    mounted () {
		if(this.companyId != 0){
			this.wxappForm.company_id =  this.companyId
			this.getdetail()
		}
    },
    methods: {
		// 编辑时获取详情
		getdetail(){
			this.loading = true
			StoreWxappDetails({
			    company_id: this.companyId
			}).then(res => {
			    if(res.code === 200 ){
					let {data} = res
			        this.wxappForm = data
			    }
			    this.loading = false
			})
		},
        //取消事件
        handleClickClose () {
            //重置表格
            this.$refs.wxappForm.resetFields()
            //关闭对话框
            this.$emit('update:wxappVisible', false)
        },

        //确定事件
        handleClickConfirm () {
            this.$refs.wxappForm.validate(valid => {
                if (valid) {

					if(!this.wxappForm.store_wxapp_id){
						StoreWxappAdd(this.wxappForm).then(res=>{
						    // 验证通过调用新增菜单接口
						    this.$message.success('新增成功')
						    //调用取消事件
						    this.handleClickClose()
						    //父页面刷新列表
						    this.$emit('success')
						})
					}else{
						StoreWxappEdit(this.wxappForm).then(res=>{
						    // 验证通过调用新增菜单接口
						    this.$message.success('编辑成功')
						    //调用取消事件
						    this.handleClickClose()
						    //父页面刷新列表
						    this.$emit('success')
						})
					}


                } else {
                    return false
                }
            })
        },
    },

}
</script>
<style lang="scss" scoped>
.hint {
    font-size: 12px;
	line-height: 16px;
    color: #888888;
	margin-top: 5px;
}
</style>
